import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

/**
 * @file PopperCore
 */
import { isClient } from '@tencent/glue-util-boundary';
var DATA_SET_ID_TAG = Symbol('__dataSetIds__');
export var PopperCore = /*#__PURE__*/function () {
  function PopperCore() {
    var _this = this;

    _classCallCheck(this, PopperCore);

    this.popperMap = {};
    this.eventFlag = false;

    this.onDocumentContextMenuCapture = function (e) {
      var target = e.target;
      var dataSetId = [];
      var ele = target;

      while (ele && ele !== document.body) {
        if (ele.nodeType === 1) {
          var id = ele.getAttribute('data-rc-id') || '';

          if (id) {
            dataSetId.push(id);
          }
        }

        ele = ele.parentNode;
      }

      e[DATA_SET_ID_TAG] = dataSetId;
    };

    this.onDocumentClickCapture = function (e) {
      var target = e.target;
      var dataSetId = [];
      var ele = target;

      while (ele && ele !== document.body) {
        if (ele.nodeType === 1) {
          var id = ele.getAttribute('data-rc-id') || '';

          if (id) {
            dataSetId.push(id);
          }
        }

        ele = ele.parentNode;
      }

      e[DATA_SET_ID_TAG] = dataSetId;
    };

    this.onDocumentClick = function (e) {
      var dataSetId = e[DATA_SET_ID_TAG] || [];

      var popperList = _this.getPopperList();

      if (!dataSetId.length) {
        popperList.forEach(function (popper) {
          popper.hideAllPopover('click');
          popper.hideAllPopover('contextmenu');
        });
        return;
      } // 收集popover信息，确定不需要关闭的popover


      var popoverIdsMap = {};
      dataSetId.forEach(function (setId) {
        var _setId$split = setId.split('___'),
            _setId$split2 = _slicedToArray(_setId$split, 2),
            type = _setId$split2[0],
            id = _setId$split2[1];

        if (type === 'popover') {
          popoverIdsMap[id] = true;
        }
      });
      var excludeIds = []; // 保留相关的click popover，关闭不相关的popover

      Object.keys(popoverIdsMap).forEach(function (popoverId) {
        popperList.forEach(function (popper) {
          var showIds = popper.getShowIds();

          if (showIds.indexOf(popoverId) >= 0) {
            var popoverUnionIds = popper.getPopover(popoverId).getUnionPopoverIds();
            excludeIds = excludeIds.concat([popoverId].concat(_toConsumableArray(popoverUnionIds)));
          }
        });
      });
      var setId = dataSetId[0];

      var _setId$split3 = setId.split('___'),
          _setId$split4 = _slicedToArray(_setId$split3, 2),
          type = _setId$split4[0],
          id = _setId$split4[1];

      if (type !== 'trigger') {
        popperList.forEach(function (popper) {
          return popper.hideAllPopover('click', excludeIds);
        });
        return;
      }

      popperList.forEach(function (popper) {
        var trigger = popper.getTrigger(id);

        if (!trigger || trigger.getTriggerType() !== 'click') {
          popper.hideAllPopover('click', excludeIds); // 点击弹层要把右键关掉

          popper.hideAllPopover('contextmenu', excludeIds);
          return;
        }

        if (trigger.isActiveShow() && !trigger.getDisableToggleClose()) {
          popper.hideAllPopover('click', excludeIds);
          popper.hideAllPopover('contextmenu', excludeIds);
          return;
        }

        popper.hideAllPopover('click', excludeIds);
        trigger.showPopper();
      });
    };

    this.onDocumentContextMenu = function (e) {
      var _a, _b;

      var dataSetId = e[DATA_SET_ID_TAG] || [];

      var popperList = _this.getPopperList();

      if (!dataSetId.length) {
        popperList.forEach(function (popper) {
          popper.hideAllPopover('click'); // 其他区域触发系统右键，也关掉

          popper.hideAllPopover('contextmenu');
        });
        return;
      } // 收集popover信息，确定不需要关闭的popover


      var popoverIdsMap = {};
      dataSetId.forEach(function (setId) {
        var _setId$split5 = setId.split('___'),
            _setId$split6 = _slicedToArray(_setId$split5, 2),
            type = _setId$split6[0],
            id = _setId$split6[1];

        if (type === 'popover') {
          popoverIdsMap[id] = true;
        }
      });
      var excludeIds = []; // 保留相关的click popover，关闭不相关的popover

      Object.keys(popoverIdsMap).forEach(function (popoverId) {
        popperList.forEach(function (popper) {
          var showIds = popper.getShowIds();

          if (showIds.indexOf(popoverId) >= 0) {
            var popoverUnionIds = popper.getPopover(popoverId).getUnionPopoverIds();
            excludeIds = excludeIds.concat([popoverId].concat(_toConsumableArray(popoverUnionIds)));
          }
        });
      });
      var setId = dataSetId[0];

      var _setId$split7 = setId.split('___'),
          _setId$split8 = _slicedToArray(_setId$split7, 2),
          type = _setId$split8[0],
          id = _setId$split8[1];

      if (type !== 'trigger') {
        popperList.forEach(function (popper) {
          return popper.hideAllPopover('click', excludeIds);
        }); // 如果点了右键，当做左键

        e.preventDefault();
        (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.click) === null || _b === void 0 ? void 0 : _b.call(_a);
        return;
      }

      popperList.forEach(function (popper) {
        var trigger = popper.getTrigger(id);

        if (!trigger || trigger.getTriggerType() !== 'contextmenu') {
          popper.hideAllPopover('click', excludeIds); // 把其他contextmenu关掉

          popper.hideAllPopover('contextmenu', excludeIds);
          return;
        }

        if (trigger.isActiveShow() && !trigger.getDisableToggleClose()) {
          popper.hideAllPopover('click', excludeIds);
          return;
        }

        popper.hideAllPopover('contextmenu', excludeIds);
        trigger.showPopper();
        e.preventDefault();
      });
    };
  }

  _createClass(PopperCore, [{
    key: "addPopper",
    value: function addPopper(popper) {
      this.popperMap[popper.getId()] = popper;
    }
  }, {
    key: "removePopper",
    value: function removePopper(popper) {
      var id = popper.getId();

      if (this.popperMap[id]) {
        delete this.popperMap[id];
      }

      if (!Object.keys(this.popperMap).length) {
        this.eventFlag = false;

        if (isClient()) {
          document.removeEventListener('click', this.onDocumentClickCapture, true);
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('contextmenu', this.onDocumentContextMenuCapture, true);
          document.removeEventListener('contextmenu', this.onDocumentContextMenu);
        }
      }
    }
  }, {
    key: "initPopperCoreEvent",
    value: function initPopperCoreEvent() {
      if (!this.eventFlag) {
        this.eventFlag = true;

        if (isClient()) {
          document.addEventListener('click', this.onDocumentClickCapture, true);
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('contextmenu', this.onDocumentContextMenuCapture, true);
          document.addEventListener('contextmenu', this.onDocumentContextMenu);
        }
      }
    }
  }, {
    key: "getPopperList",
    value: function getPopperList() {
      var _this2 = this;

      return Object.keys(this.popperMap).map(function (id) {
        return _this2.popperMap[id];
      });
    }
  }]);

  return PopperCore;
}();
export var popperCore = new PopperCore();